export type KahuLink =
  | { type: 'app'; slug: string }
  | { type: 'workflow'; slug: string }
  | {
      type: 'fact';
      slug: string;
      factName: string;
      appId: string;
      factId: string;
    }
  | { type: 'unknown'; href: string };

export function parseKahuHref(href: string): KahuLink {
  const factMatch = href.match(
    /^okahu:\/\/apps\/([^/]+)\/facts\/([^/]+)\/([^/]+)$/
  );

  const workflowMatch = href.match(/^okahu:\/\/workflows\/([^/]+)$/);

  if (workflowMatch) {
    return { type: 'workflow', slug: workflowMatch[1] };
  }

  if (factMatch) {
    return {
      type: 'fact',
      slug: factMatch[1],
      appId: factMatch[1],
      factName: factMatch[2],
      factId: factMatch[3],
    };
  }

  // App: okahu://apps/{slug}
  const appMatch = href.match(/^okahu:\/\/apps\/([^/]+)$/);
  if (appMatch) {
    return { type: 'app', slug: appMatch[1] };
  }

  return { type: 'unknown', href };
}

export function buildKahuLinkPath(parsed: KahuLink): string | null {
  // /en/components/okahu_demos_llamaindex_travel_agent_tests
  switch (parsed.type) {
    case 'workflow':
      return `/en/components/${parsed.slug}`;
    case 'app':
      return `/en/apps/${parsed.slug}/`;
    case 'fact':
      return `/en/apps/${parsed.appId}/traces?trace_id=${parsed.factId}&factName=${parsed.factName}&viewBy=all&activeTab=search`;
    case 'unknown':
      return null;
  }
}
